import React from 'react';
import PropTypes from 'prop-types';

// var ImageEntity = React.createClass({
//     displayName: 'ImageEntity',
//     mixins: [ ],
//     propTypes: {
//         entity: PropTypes.any
//     },
//     render: function() {
//         var entity = this.props.entity;
//         return (
//             <a className='image-entity' href={ entity.getImageLink() } target="_blank">
//                 <img src={ entity.getImageUrl() } />
//             </a>
//         );
//     }
// });

class ImageEntity extends React.Component {
  static displayName = 'ImageEntity';

  static propTypes = {
    entity: PropTypes.any
  };
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    var entity = this.props.entity;
    return (
      <a className="image-entity" href={entity.getImageLink()} target="_blank">
        <img src={entity.getImageUrl()} />
      </a>
    );
  }
}

export default ImageEntity;
